import React, { useState, useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';
import '../styles/Objective.css';

const ObjectiveCallout = ({ text, status }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [displayStatus, setDisplayStatus] = useState(status);
  const rippleRef = useRef(null);
  const colorStatus = displayStatus === 'green' ? 'green' : 'yellow';

  const triggerConfetti = () => {
    if (rippleRef.current) {
      const rect = rippleRef.current.getBoundingClientRect();
      const x = (rect.left + rect.width / 2) / window.innerWidth;
      const y = (rect.top + rect.height / 2) / window.innerHeight;
      // const w = window.innerWidth;
      
      confetti({
        particleCount: 30,
        spread: 100,
        origin: { x, y },
        colors: ['#00ff00', '#FFD700', '#FF69B4', '#4169E1', '#9B59B6', '#FFA500', '#00CED1']
      });
    }
  };

  useEffect(() => {
    if (status === 'yellow' && displayStatus === 'green') {
      setDisplayStatus('yellow');
    } else {
      setDisplayStatus(status);
      if (status === 'green') {
        triggerConfetti();
      }
    }
  }, [status, displayStatus]);

  return (
    <div className={`objective-container ${isVisible ? 'fade-enter-active' : 'fade-enter'}`}>
      <div className={`target-marker ${colorStatus}`}>
        <div ref={rippleRef} className="ripple"></div>
        <div className="ripple"></div>
      </div>
      <span className="objective-text">{text}</span>
    </div>
  );
};

export default ObjectiveCallout; 